module.exports = __webpack_public_path__ + "assets/0103_IFOK_WIM_MARKER_blue_topic_je.be219b70.svg";